import { render, staticRenderFns } from "./template-filter.vue?vue&type=template&id=2673889e"
import script from "./template-filter.vue?vue&type=script&lang=js"
export * from "./template-filter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports